import { render, staticRenderFns } from "./PublicPlayer.vue?vue&type=template&id=10d5a612&"
import script from "./PublicPlayer.vue?vue&type=script&lang=js&"
export * from "./PublicPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports